/**
 * Referência do contrato de GET /admin/dashboard e GET /admin/reports
 * (e recortes /admin/reports/clients|financial|courses-sales).
 * Usado como fixture de shape; as views consomem a API real (sem fallback automático).
 */

const companiesBySystem = [
    { label: 'Weeduc', value: 42, color: '#250891' },
    { label: 'Weflix', value: 18, color: '#1AC7D0' },
];

const weeducByBusiness = [
    { label: 'Escolar', value: 25, color: '#250891' },
    { label: 'Corporativo', value: 17, color: '#7C5CFC' },
];

const topByStudents = [
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, students: 8420 },
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, students: 6150 },
    { id: 21, name: 'Instituto Nova Era', typeSystem: 1, typeBusiness: 1, students: 4980 },
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, students: 3720 },
    { id: 15, name: 'Escola Plural', typeSystem: 1, typeBusiness: 1, students: 3105 },
];

const topByRevenue = [
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, revenue: 485000 },
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, revenue: 392000 },
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, revenue: 318500 },
    { id: 9, name: 'StreamLearn Brasil', typeSystem: 2, typeBusiness: null, revenue: 276800 },
    { id: 21, name: 'Instituto Nova Era', typeSystem: 1, typeBusiness: 1, revenue: 241200 },
];

const topBySales = [
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, sales: 1840 },
    { id: 9, name: 'StreamLearn Brasil', typeSystem: 2, typeBusiness: null, sales: 1522 },
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, sales: 1180 },
    { id: 18, name: 'Portal Mentoria Plus', typeSystem: 2, typeBusiness: null, sales: 965 },
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, sales: 740 },
];

const topByCourses = [
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, courses: 286 },
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, courses: 214 },
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, courses: 198 },
    { id: 21, name: 'Instituto Nova Era', typeSystem: 1, typeBusiness: 1, courses: 167 },
    { id: 15, name: 'Escola Plural', typeSystem: 1, typeBusiness: 1, courses: 142 },
];

const revenueTrend = [
    { month: 1, year: 2026, value: 210000 },
    { month: 2, year: 2026, value: 245000 },
    { month: 3, year: 2026, value: 268000 },
    { month: 4, year: 2026, value: 292000 },
    { month: 5, year: 2026, value: 310000 },
    { month: 6, year: 2026, value: 355000 },
    { month: 7, year: 2026, value: 372000 },
    { month: 8, year: 2026, value: 401000 },
    { month: 9, year: 2026, value: 428000 },
];

const companiesTrend = [
    { month: 1, year: 2026, value: 38 },
    { month: 2, year: 2026, value: 41 },
    { month: 3, year: 2026, value: 44 },
    { month: 4, year: 2026, value: 47 },
    { month: 5, year: 2026, value: 50 },
    { month: 6, year: 2026, value: 53 },
    { month: 7, year: 2026, value: 55 },
    { month: 8, year: 2026, value: 58 },
    { month: 9, year: 2026, value: 60 },
];

const reportClients = [
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, students: 8420, courses: 214, revenue: 318500, sales: 740, createdAt: '2023-02-14' },
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, students: 6150, courses: 286, revenue: 485000, sales: 1180, createdAt: '2022-11-03' },
    { id: 21, name: 'Instituto Nova Era', typeSystem: 1, typeBusiness: 1, students: 4980, courses: 167, revenue: 241200, sales: 520, createdAt: '2023-06-21' },
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, students: 3720, courses: 198, revenue: 392000, sales: 1840, createdAt: '2023-01-09' },
    { id: 15, name: 'Escola Plural', typeSystem: 1, typeBusiness: 1, students: 3105, courses: 142, revenue: 198400, sales: 410, createdAt: '2024-03-18' },
    { id: 9, name: 'StreamLearn Brasil', typeSystem: 2, typeBusiness: null, students: 2890, courses: 121, revenue: 276800, sales: 1522, createdAt: '2023-09-02' },
    { id: 18, name: 'Portal Mentoria Plus', typeSystem: 2, typeBusiness: null, students: 2140, courses: 95, revenue: 164300, sales: 965, createdAt: '2024-01-27' },
    { id: 4, name: 'Rede Saber Corporativo', typeSystem: 1, typeBusiness: 2, students: 1980, courses: 88, revenue: 152700, sales: 380, createdAt: '2024-05-11' },
    { id: 28, name: 'Campus Digital Sul', typeSystem: 1, typeBusiness: 1, students: 1760, courses: 76, revenue: 128900, sales: 290, createdAt: '2024-07-08' },
    { id: 31, name: 'Flix Academy Pro', typeSystem: 2, typeBusiness: null, students: 1540, courses: 64, revenue: 119500, sales: 710, createdAt: '2024-08-19' },
];

const reportFinancial = [
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, period: '2026-09', revenue: 52000, fees: 4680, net: 47320 },
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, period: '2026-09', revenue: 44800, fees: 4032, net: 40768 },
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, period: '2026-09', revenue: 36500, fees: 3285, net: 33215 },
    { id: 9, name: 'StreamLearn Brasil', typeSystem: 2, typeBusiness: null, period: '2026-09', revenue: 31200, fees: 2808, net: 28392 },
    { id: 21, name: 'Instituto Nova Era', typeSystem: 1, typeBusiness: 1, period: '2026-09', revenue: 27800, fees: 2502, net: 25298 },
    { id: 18, name: 'Portal Mentoria Plus', typeSystem: 2, typeBusiness: null, period: '2026-09', revenue: 22100, fees: 1989, net: 20111 },
    { id: 15, name: 'Escola Plural', typeSystem: 1, typeBusiness: 1, period: '2026-09', revenue: 19800, fees: 1782, net: 18018 },
    { id: 4, name: 'Rede Saber Corporativo', typeSystem: 1, typeBusiness: 2, period: '2026-09', revenue: 17500, fees: 1575, net: 15925 },
];

const reportCoursesSales = [
    { id: 7, name: 'Grupo Educacional Atlas', typeSystem: 1, typeBusiness: 2, courses: 286, sales: 1180, avgTicket: 411.02 },
    { id: 3, name: 'Academia TechCorp', typeSystem: 2, typeBusiness: null, courses: 198, sales: 1840, avgTicket: 213.04 },
    { id: 12, name: 'Colégio Horizonte', typeSystem: 1, typeBusiness: 1, courses: 214, sales: 740, avgTicket: 430.41 },
    { id: 9, name: 'StreamLearn Brasil', typeSystem: 2, typeBusiness: null, courses: 121, sales: 1522, avgTicket: 181.87 },
    { id: 21, name: 'Instituto Nova Era', typeSystem: 1, typeBusiness: 1, courses: 167, sales: 520, avgTicket: 463.85 },
    { id: 18, name: 'Portal Mentoria Plus', typeSystem: 2, typeBusiness: null, courses: 95, sales: 965, avgTicket: 170.26 },
    { id: 15, name: 'Escola Plural', typeSystem: 1, typeBusiness: 1, courses: 142, sales: 410, avgTicket: 483.90 },
    { id: 31, name: 'Flix Academy Pro', typeSystem: 2, typeBusiness: null, courses: 64, sales: 710, avgTicket: 168.31 },
];

export const dashboardMock = {
    isMock: true,
    summary: {
        totalCompanies: 60,
        weeduc: 42,
        weflix: 18,
        escolar: 25,
        corporativo: 17,
        totalStudents: 48620,
        totalRevenue: 2845600,
        totalCourses: 2148,
        totalSales: 12640,
        pendingApprovals: 4,
    },
    companiesBySystem,
    weeducByBusiness,
    topByStudents,
    topByRevenue,
    topBySales,
    topByCourses,
    revenueTrend,
    companiesTrend,
};

export const reportsMock = {
    isMock: true,
    clients: reportClients,
    financial: reportFinancial,
    coursesSales: reportCoursesSales,
};

export default dashboardMock;
